"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("card/base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp;

var DiscussionCard = (_class = (_temp =
/*#__PURE__*/
function (_Card) {
  babelHelpers.inherits(DiscussionCard, _Card);

  function DiscussionCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "pageId", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "accountProfileImage", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "icons", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "date", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "comment", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "group", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "topicLink", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionCard, [{
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      return _react.default.createElement("div", {
        className: "comment-items",
        "data-type": this.pageId
      }, _react.default.createElement("div", {
        className: "account-image"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        componentName: "span",
        className: "user-profile-image",
        noImageClassName: "initials",
        image: this.accountProfileImage,
        name: this.name
      })), _react.default.createElement("div", {
        className: "details"
      }, _react.default.createElement("p", {
        className: "title"
      }, this.objectTitle), _react.default.createElement("div", {
        className: "author-info"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "subdirectory_arrow_right"
      }), _react.default.createElement("p", null, _react.default.createElement("span", {
        className: "bold"
      }, this.name, this.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          className: "account-icon",
          src: icon.icon,
          title: icon.title,
          key: icon.id
        });
      }))), " replied ", this.formatDate()))));
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("h3", null, this.objectTitle), _react.default.createElement("div", {
        className: "comment-body"
      }, _react.default.createElement("p", {
        className: _classList.default.join('summary post-body', this.comment.length > 160 ? 'truncated' : '')
      }, this.comment.substring(0, 160), this.comment.length > 160 ? _react.default.createElement("span", null, "\u2026") : null), this.group && _react.default.createElement("div", {
        className: "topic"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "chat"
      }), _react.default.createElement("p", null, this.group))));
    }
  }, {
    key: "renderTileFooter",
    value: function renderTileFooter() {
      return null;
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      return null;
    }
  }, {
    key: "renderAdditionalTileContents",
    value: function renderAdditionalTileContents() {
      return _react.default.createElement("div", {
        className: "discussion-tile-body"
      }, _react.default.createElement("a", {
        href: this.linkTarget,
        className: "discussion-top"
      }, _react.default.createElement("div", {
        className: "author"
      }, _react.default.createElement("div", {
        className: "account-image"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        componentName: "span",
        className: "user-profile-image",
        noImageClassName: "initials",
        image: this.accountProfileImage,
        name: this.name
      })), _react.default.createElement("div", {
        className: "author-info"
      }, _react.default.createElement("p", null, _react.default.createElement("span", {
        className: "bold"
      }, this.name, this.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          className: "account-icon",
          src: icon.icon,
          title: icon.title,
          key: icon.id
        });
      }))), " replied ", this.formatDate))), _react.default.createElement("p", {
        className: _classList.default.join('summary', 'post-body', this.object.comment.length > 160 && 'truncated')
      }, this.comment.substring(0, 160), this.comment.length > 160 ? _react.default.createElement("span", null, "\u2026") : null)), _react.default.createElement("div", {
        className: "discussion-bottom"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "comment"
      }), _react.default.createElement("div", {
        className: "topic-info"
      }, this.group && _react.default.createElement("div", {
        className: "group"
      }, this.group), _react.default.createElement("a", {
        href: this.topicLink,
        className: "topic"
      }, this.objectTitle))));
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      var d = new Date(this.date * 1000),
          now = Date.now();
      if (d.getTime() > now - 60000) return "now";

      if (d.getTime() > now - 3600000) {
        var minutes = (now - d.getTime()) / 60000;
        minutes = Math.round(minutes);
        return "".concat(minutes, " minute").concat(minutes == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 86400000) {
        var hours = (now - d.getTime()) / 3600000;
        hours = Math.floor(hours);
        return "".concat(hours, " hour").concat(hours == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 7 * 86400000) {
        var days = (now - d.getTime()) / 86400000;
        days = Math.floor(days);
        return "".concat(days, " day").concat(days == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 365 * 86400000) {
        return d.format('M j');
      }

      return d.format('M j, Y');
    }
  }]);
  return DiscussionCard;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "pageId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "accountProfileImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "date", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "comment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "group", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "topicLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = DiscussionCard;